<template>
  <div class="selQuestion">
    <!-- 题库挑题弹出框 -->
    <div class="bodyPanel">
      <el-row :gutter="10">
        <el-col :span="6" style=" height: 85vh; display: flex;flex-direction: column;">
          <el-row style="height: 40px;">
            <el-col :span="10" style="display: flex;">
              <el-button type="text" size="small">
                {{ this.selection.subject.Name }}
                <i class="el-icon-arrow-down"></i>
              </el-button>
              <select-city @update="updateCity"></select-city>
            </el-col>
            <el-col :span="14">
              <el-button-group class="type-btn-select">
                <el-button :class="pageStyle.chapterActive ? 'actived' : ''" type="primary" size="small"
                  @click="selectType(1)">
                  章节挑题
                </el-button>
                <el-button :class="pageStyle.knowledgeActive ? 'actived' : ''" type="primary" size="small"
                  @click="selectType(2)">
                  知识点挑题
                </el-button>
              </el-button-group>
            </el-col>
          </el-row>
          <!-- 章节挑题 -->
          <div v-if="pageStyle.chapterActive" class="chapterBox">
            <el-card shadow="never">
              <div slot="header" class="clearfix chapterTitle">
                <el-tooltip class="item" effect="dark" :content="teachingMaterial.BookName" placement="bottom">
                  <span>{{ teachingMaterial.Title }}</span>
                </el-tooltip>

                <el-button style="float: right; padding: 3px 0" type="text" @click="showTeachingMaterial">
                  <i class="el-icon-setting"></i>
                </el-button>
              </div>
              <div class="text item">
                <el-tree class="custom-tree-lines" :data="chapters" :props="chapterProps" node-key="id" accordion
                  @node-click="treeNodeClick">
                  <span slot-scope="{ node, data }" class="custom-tree-node">
                    <template>
                      <i :class="data.data.length > 0
                        ? node.expanded
                          ? 'el-icon-remove-outline'
                          : 'el-icon-circle-plus-outline'
                        : 'el-icon-document'
                        " style="color: #409eff; margin-right: 5px" />
                      <span>{{ node.label }}</span>
                    </template>
                  </span>
                </el-tree>
              </div>
            </el-card>
          </div>
          <!-- 知识点挑题 -->
          <div v-else class="knowledgeBox">
            <el-card shadow="never">
              <div slot="header" class="clearfix">
                <el-input placeholder="请输入2-10个考点关键字" size="small" v-model="knowledge.keyword"></el-input>
              </div>
              <div class="multiBox flex align-center justify-around">
                <div>
                  <span>知识点多选</span>
                  <el-switch v-model="knowledge.isMulti"></el-switch>
                </div>
                <div class="flex align-center">
                  <el-radio-group v-model="condition.params.OnlyNos">
                    <el-radio style="margin-right: 12px;" :label="2" :value="2">交集</el-radio>
                    <el-radio style="margin-right: 12px;" :label="1" :value="1">并集</el-radio>
                  </el-radio-group>
                  <el-tooltip effect="light" placement="bottom">
                    <div slot="content">
                      <div class="margin-bottom-sm">考点交集：每一道试题考点均涵盖选择的所有考点（不可超过三个考点）</div>
                      <div class="margin-top-sm">考点并集：每一道试题考点涵盖选择的某一考点或多个考点</div>
                    </div>
                    <div style="cursor: pointer;">
                      <i class="el-icon-question" style="font-size: 16px;"></i>
                    </div>
                  </el-tooltip>
                </div>
              </div>
              <el-tree class="filter-tree custom-tree-lines" :data="knowledge.list" :props="knowledgeProps"
                node-key="No" accordion :check-strictly="true" :show-checkbox="knowledge.isMulti"
                @node-click="knowledgeNodeClick" @check-change="knowledgeCheckChange"
                :filter-node-method="filterKnowledgeNode">
                <span slot-scope="{ node, data }">
                  <!-- class="custom-tree-node" -->
                  <template>
                    <!-- <i :class="data.datalist && data.datalist.length > 0
                      ? node.expanded
                        ? 'el-icon-remove-outline'
                        : 'el-icon-circle-plus-outline'
                      : 'el-icon-document'
                      " style="color: #409eff; margin-right: 5px" /> -->
                    <span style="font-size: 14px;">{{ data.Name }}</span>
                  </template>
                </span>
              </el-tree>
            </el-card>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="conditionBox">
            <el-row>
              <el-col :span="3" class="first">
                <label>题型：</label>
              </el-col>
              <el-col :span="21">
                <el-button size="mini" :type="condition.params.QuestionType === item.TypeId ? 'primary' : 'text'"
                  v-for="item in condition.data.QuestionType" :key="item.TypeId"
                  @click="changeQuestionType(item.TypeId)" plain>
                  {{ item.Name }}
                </el-button>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3" class="first">
                <label>难度：</label>
              </el-col>
              <el-col :span="21">
                <el-button size="mini" :type="condition.params.DifficultyLevel === item.Key ? 'primary' : 'text'"
                  v-for="item in condition.data.DifficultyLevel" :key="item.Key"
                  @click="changeDifficultyLevel(item.Key)" plain>
                  {{ item.Value }}
                </el-button>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="3" class="first">
                <label>题类：</label>
              </el-col>
              <el-col :span="21">
                <el-button size="mini" :type="condition.QuestionCategoryID === item.ID ? 'primary' : 'text'"
                  v-for="item in condition.data.QuestionCategorys" :key="item.ID" @click="changeQuestionCategory(item)"
                  plain>
                  {{ item.Name }}
                </el-button>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="3" class="first">
                <label>来源：</label>
              </el-col>
              <el-col :span="21">
                <el-button size="mini" :type="condition.params.QuestionSources === item.ID ? 'primary' : 'text'"
                  v-for="item in condition.data.QuestionSource" :key="item.ID" @click="changeQuestionSource(item.ID)"
                  plain>
                  {{ item.Name }}
                </el-button>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="3" class="first">
                <label>年份：</label>
              </el-col>
              <el-col :span="21">
                <el-button size="mini" :type="condition.ExamYearID == item ? 'primary' : 'text'"
                  v-for="(item, index) in condition.data.YearList" :key="index" @click="changeExamYear(item)" plain>
                  {{ item }}
                </el-button>
              </el-col>
            </el-row>

            <el-row v-if="condition.data.QuestionAbility.length > 1">
              <el-col :span="3" class="first">
                <label>能力：</label>
              </el-col>
              <el-col :span="21">
                <!-- {{ condition.params.TopicNo }}  -=-   {{ item.AbilityId }} -->
                <el-button size="mini" :type="condition.params.TopicNo == item.AbilityId ? 'primary' : 'text'"
                  v-for="item in condition.data.QuestionAbility" :key="item.AbilityId"
                  @click="changeAbility(item.AbilityId)" plain>
                  {{ item.Name }}
                </el-button>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3" class="first">
                <label>排序：</label>
              </el-col>
              <el-col :span="12">
                <el-button size="mini" :type="condition.params.Sort === 0 ? 'primary' : 'text'" plain
                  @click="sortQuestionList(0)">
                  综合排序
                  <span v-show="condition.params.Sort === 0">
                    <i v-if="condition.params.Desc == 1" class="el-icon-bottom"></i>
                    <i v-else-if="condition.params.Desc == 0" class="el-icon-top"></i>
                  </span>
                </el-button>
                <el-button :type="condition.params.Sort === 1 ? 'primary' : 'text'" size="mini" plain
                  @click="sortQuestionList(1)">
                  组卷次数
                  <span v-show="condition.params.Sort === 1">
                    <i v-if="condition.params.Desc == 1" class="el-icon-bottom"></i>
                    <i v-else-if="condition.params.Desc == 0" class="el-icon-top"></i>
                  </span>
                </el-button>

                <el-button :type="condition.params.Sort === 2 ? 'primary' : 'text'" size="mini" plain
                  @click="sortQuestionList(2)">
                  真题次数
                  <span v-show="condition.params.Sort === 2">
                    <i v-if="condition.params.Desc == 1" class="el-icon-bottom"></i>
                    <i v-else-if="condition.params.Desc == 0" class="el-icon-top"></i>
                  </span>
                </el-button>

                <el-button :type="condition.params.Sort === 3 ? 'primary' : 'text'" size="mini" plain
                  @click="sortQuestionList(3)">
                  试题难度
                  <span v-show="condition.params.Sort === 3">
                    <i v-if="condition.params.Desc == 1" class="el-icon-bottom"></i>
                    <i v-else-if="condition.params.Desc == 0" class="el-icon-top"></i>
                  </span>
                </el-button>
              </el-col>
              <el-col :span="9">
                <el-button type="primary" @click="search">搜索</el-button>
              </el-col>
            </el-row>
          </div>
          <div style="background-color: #fff;" class="padding-tb questionListBox">
            <template v-if="emptyData">
              <div class="flex justify-center align-center" style="margin: 100px auto;">暂无数据</div>
            </template>
            <template v-else>
              <!-- :hasCorrect="true" 暂时设置false隐藏掉试题纠错功能20250310 -->
              <question-bank-list ref="questionBankListRef" :questions="QuestionList.DataList"
                :typeName="'SelectQuestionBank'" :PaperID="paperId" pushEnable @removePush="removePush"
                @addPush="addPush" @similarQuestions="similarqueHandler"
                @errorCorrectionSave="errorCorrectionSave"></question-bank-list>
              <!-- 分页 -->
              <div class="text-right">
                <el-pagination :current-page.sync="quesBankPagination.PageIndex"
                  :page-size.sync="quesBankPagination.PageSize" :pager-count="5" :total="quesBankPagination.TotalSize"
                  layout="prev, pager, next" @current-change="quesbankpaginationChange"></el-pagination>
                <!--  @size-change="getQuestionList" -->
              </div>
            </template>

          </div>
        </el-col>
      </el-row>
    </div>
    <div class="dialogArea">
      <el-dialog title="提示" custom-class="similar-dialog s-d" :visible.sync="similarDialogVisible" :append-to-body="false"
        top="5vh" v-dialogDrag :close-on-click-modal="false" style="overflow: hidden" @close="closeSimilar">
        <div slot="title" class="searchTitle">
          <span style="font-size: 20px">相似题</span>
          <a v-if="similarLoadedData.length >= 5 && similarLoadedData.length <= 10" href="#" class="change-one"
            @click="changeSimilar">
            <i class="el-icon-refresh"></i>
            <span style="text-decoration: underline;">换一批</span>
          </a>
        </div>
        <!-- 相似题列表 -->
        <question-bank-list :questions="similarData" :typeName="'similarData'" :hasFavorite="false"
          @similarQuestions="similarQuestions" pushEnable @removePush="removePush"
          @addPush="addPush"></question-bank-list>
      </el-dialog>


      <!--    选择教材-->
      <el-dialog class="teachingMaterialDialog" :visible.sync="teachingMaterial.visible" :append-to-body="true"
        title="选择教材" width="600px" @close="closeTeachingMaterial">
        <div class="teachingMaterial">
          <el-cascader ref="teachingMaterial" v-model="teachingMaterial.Data" size="small"
            :options="teachingMaterial.Options" :props="teachingMaterial.LazyChapter" clearable
            @change="teachingMaterialChange"></el-cascader>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeTeachingMaterial">取 消</el-button>
          <el-button size="small" type="primary" @click="sureTeachingMaterial">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import provinceData from "@/assets/data/citys.json";
import QuestionBankList from "./QuestionBankList.vue";
import SelectCity from "./SelectCity.vue";
import store from '@/store/store.js'

// this.axios({
//         method: "GET",
//         url: window.hosturl + "/rest/ExerciseBook/GetExerciseBookPages",
//         params: this.pagesCondition,
//       }).then((res) => {
//         if (res.data.result !== 200) {
//           this.$message.error("获取失败.");
//           return;
//         }
//       })

export default {
  name: 'SelQuestion', // 布置作业的某个题目的题库挑题
  components: {
    QuestionBankList,
    "select-city": SelectCity,
  },
  props: {
    taskData: {
      type: Object,
      default: {
        ID: 0, //作业id,
        PublishID: 0,
        Name: "", //作业的名称
        //HomeworkDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
        HomeworkDate: new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate(),
        //SchoolId: '',//学校
        classList: [], //ClassID: [],//下发的班级id（多个参数用逗号隔开）
        classListName: [],
        IsScore: 0, //是否计分制
        IsOnline: "0", //在线作业还是传题选题.
        // cascaderChapter: [ "10001","173377","173378","173379","173386","6563"],//五/六级菜单id.
        cascaderChapter: [], //五/六级菜单id.
        //IsCompleted: 0,//作业完成状态 0未完成未下发 1已完成并已下发
        // Questions: [],
        questionList: [],
        IsCreate: 0, // 0老师自己 1云作业直接下发
        IsShared: null, //1,共享,0未共享(取消共享)
        SharedScope: "", //1,校内共享,2全网共享.
        TestID: 0,
        SizeType: 2,
        TrueWidth: 210,
        TrueHeight: 297,
        PaddingWidth: 10, //页边距，整型，单位毫米
      }
    },
    question: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      rangeFlag: 1,

      paperId: 0, //试卷ID
      chapterProps: {
        children: "data",
        label: "name",
      },
      knowledgeProps: {
        children: "datalist",
        label: "Name",
      },

      teachingMaterial: {
        //章节懒加载配置信息
        visible: false,
        Data: [],
        //教材下拉框数据
        Options: [],
        //章节懒加载配置信息
        LazyChapter: {
          label: "name",
          value: "id",
          children: "data",
        },
        Title: "", // 选中教材的显示名称
        BookName: "请选择章节→", // 选中教材的完整名称
        isLoadCascaderChapter: false, //是否加载章节数据，250120
      },
      drawer: false,
      activeName: "first",
      pageStyle: {
        chapterActive: true,
        knowledgeActive: false,
      },
      filterText: "",
      provinces: provinceData,
      subjects: [
        {
          value: 1,
          label: "小学语文",
        },
        {
          value: 2,
          label: "小学数学",
        },
        {
          value: 3,
          label: "小学英语",
        },
        {
          value: 4,
          label: "初中语文",
        },
        {
          value: 5,
          label: "初中数学",
        },
      ],
      value: "",
      chapters: [], //章节数据

      knowledge: {
        isMulti: false,
        onlyNos: 0,
        keyword: "",
        list: [],
        multiList: [], //知识点多选列表
      },

      similarDialogVisible: false, //相似题弹窗
      similarData: [],
      similarQuestion: null,
      similarLoadedData: [],
      anotherGroupCount: 0,

      isAddAll: false, //是否全部加入试题篮
      errorDateRangeFlag: 1,

      // 绑定日期区间的变量
      dateRange: ["2024-10-8", "2024-10-10"],
      optNums: ["A", "B", "C", "D", "E", "F"],
      // 页面选择条件
      selection: {
        subject: {
          ID: 0,
          Name: "",
        },
        edition: {
          ID: 0,
          Name: "",
        },
        book: {
          ID: 0,
          Name: "",
        },
        city: {
          ID: 0,
          Name: "地区",
        },
        cityVisiable: false,
        BookTitle: "请选择章节→", // 选中教材的显示名称
      },
      emptyData: false,
      condition: {
        params: {
          Subject: 0, //科目，id
          Type: 1, //搜索类型：id，1：按教材；2：按考点
          BookID: 0, //教材
          PaperID: 0, //试卷ID
          ChapterID: 0, //章节
          KnowledgePoints: "", //知识点，多个用逗号分隔
          DifficultyLevel: 0, //难易程度0：不限；1：易（0.8到1.0）；2：较易（0.6到0.8）；3：中档（0.4到0.6）；4：较难：（0.2到0.4）；5：难：（0.0到0.2）（大于等于；小于）
          QuestionType: 0,
          ZhenTi: false,
          HaoTi: false,
          ChangKaoTi: false,
          YazhouTi: false,
          YiCuoTi: false,
          YongHuCuoTi: false,
          AreaCode: "",
          QuestionSources: 0,
          QuestionYear: "",
          TopicNo: "0", //能力标识
          OnlyNos: 0, //考点交并集（默认0）1并集2交集
          Sort: 0, //0：综合排序；1：组卷次数；2：真题次数；3：试题难度（默认0）
          Desc: 1, //降序升序\
          QuestionID: null, // 推题需要的原题ID
        },
        QuestionCategoryID: 0, // 题类（默认全部，易错题，好题）

        // QuestionSourceID: 0, // 来源（默认全部，中考真题，自主招生，中考模拟，中考复习）
        ExamYearID: "全部", // 年份（默认全部，2018，2019，2020，更早）
        // AbilityID: 0, // 能力（默认全部，数感，符号意识，空间观念，几何直观，数据分析，创新意识）
        ErrorRate: 0, //错误率
        // SortRule: 0, //排序规则

        ErrorRange: {
          Start: 30,
          End: 90,
        },
        Hardness: {
          Start: 0.3,
          End: 0.6,
        },

        // 筛选条件中的数据
        data: {
          //题型（默认全部，单选题，多选题，填空题，简答题）
          QuestionType: [
            {
              TypeId: 0,
              Name: "全部",
            },
          ],
          // 难度（默认全部，容易，较易，中档，较难，困难）
          DifficultyLevel: [
            {
              ID: 0,
              Name: "全部",
            },
          ],
          // 题类（默认全部，易错题，好题）
          QuestionCategorys: [
            {
              ID: 0,
              Key: "All",
              Name: "全部",
            },
            {
              ID: 1,
              Key: "ZhenTi",
              Name: "真题",
            },
            {
              ID: 2,
              Key: "HaoTi",
              Name: "好题",
            },
            {
              ID: 3,
              Key: "ChangKaoTi",
              Name: "常考题",
            },
            {
              ID: 4,
              Key: "YaZhouTi",
              Name: "压轴题",
            },
            {
              ID: 5,
              Key: "YiCuoTi",
              Name: "易错题",
            },
            {
              ID: 6,
              Key: "YongHuCuoTi",
              Name: "用户错题",
            },
          ],
          // 来源（默认全部，中考真题，自主招生，中考模拟，中考复习）
          QuestionSource: [
            {
              ID: 0,
              Name: "全部",
            },
          ],

          // 年份（默认全部，2018，2019，2020，更早）
          YearList: ["全部"],

          // 能力（默认全部，数感，符号意识，空间观念，几何直观，数据分析，创新意识）
          QuestionAbility: [
            {
              AbilityId: "0",
              Name: "全部",
            },
          ],
        },
      },
      quesBankPagination: {
        PageIndex: 1,
        PageSize: 10, // 20250308 正常应为10条，前期先临时3条 20250327 临时改为5条 20250508改为10条
        // TotalSize: 0
        TotalSize: 200, // 总记录数
      },
      QuestionList: [],
      cityList: [],
    };
  },

  created() {
    this.paperId = parseInt(this.$route.query.paperId) || 0;
    // console.log("题库挑题，created", this.paperId);
  },
  mounted() {
    //从store中获取当前用户信息
    this.initData();

    //// console.log("题库挑题，mounted", this.basket.params.paperId);
    // 获取选择教材三级菜单的下拉框数据
    this.getTeachingMaterial();
    //获取所有的查询条件
    this.getCondition();
    // 获取试题列表
    this.getQuestionList();

    this.getKnowledgeList();

    this.rangeFlag = this.dateRangeFlag;
  },
  methods: {
    // 题库列表分页change
    quesbankpaginationChange(page) {
      // // console.log(page);
      this.quesBankPagination.PageIndex = page
      this.getQuestionList()
    },
    errorCorrectionSave() {
      // // console.log('试题纠错提交');
      // // console.log(this.$refs.questionBankListRef);
      // // console.log(this.$refs.questionBankListRef.$refs.correctionform);
      const form = this.$refs.questionBankListRef.$refs.correctionform
      form.validate((valid) => {
        // // console.log(valid);
        if (!valid) return false
        // console.log('保存逻辑');
      });
    },
    similarqueHandler(queIndex, questions) { // 题库挑题 点击相似题
      // // console.log("当前题目", queIndex, questions);
      let que = questions[queIndex];
      //标记找的哪道题的相似题，换一组查询时有用
      this.similarQuestion = que.Data;

      this.similarDialogVisible = true; // 打开相似题弹出框
      this.searchSimilar(que.Data.ID, 0, que.Data.SID);
    },
    closeCollect() { // 收藏夹弹出框关闭
      this.getQuestionList() // 关闭的时候加载一下列表，因为修改了一些取消收藏或移出试题篮的状态
    },
    /* 监听相似题窗口关闭，重置已加载的相似题 */
    closeSimilar() {
      this.similarLoadedData = [];
      this.similarData = [];
      this.similarQuestion = null;
      this.anotherGroupCount = 0;
    },
    /* 搜题结果中查找相似题queIndex:题库题目列表题目序号，questions：题库题目列表 */
    similarQuestions(queIndex, questions) {
      // console.log("当前题目", queIndex, questions);
      let que = questions[queIndex];
      this.similarQuestion = que;
      this.searchSimilar(que.Data.ID, 0, que.Data.SID);
    },
    /* 换一组相似题 */
    changeSimilar() {
      let SID;
      let NID = "";
      let similarQuestion = this.similarQuestion;
      if (this.similarLoadedData.length + this.similarData.length <= 10) {
        // nid最多支持10个，不超10的情况
        this.similarLoadedData = this.similarLoadedData.concat(this.similarData);
        if (this.similarLoadedData.length > 0) {
          for (let q of this.similarLoadedData) {
            NID = NID.concat(q.Data.SID + ",");
          }
          NID = NID.substring(0, NID.length - 1);
        }
        SID = similarQuestion.Data.SID;
      } else {
        // nid已足10个  不能再增加，sid取最新一组数据的第一条
        SID = this.similarData[0].Data.SID;
      }
      // 记录换一组点击的次数
      this.anotherGroupCount++;
      this.searchSimilar(this.similarQuestion.Data.ID, 0, SID, NID);
    },
    /* 获取相似题接口，更新数据；similarQuestionID：原题目的id；sourceType：原题目来源1教辅题，2作业题，3错题本的题，0其他；SID：关联题库的sid；NID：排除的sid */
    searchSimilar(similarQuestionID, sourceType, SID, NID) {
      this.axios({
        method: "GET",
        url: window.hosturl + "/rest/questionBank/GetSimilarQuestions",
        params: {
          SID: SID,
          TaskQuestionID: similarQuestionID,
          NID: NID ? NID : "",
        },
      }).then((res) => {
        if (res.data.result == 200) {
          this.similarData = res.data.data;
          if (this.similarData && this.similarData.length) {
            this.similarLoadedData = this.similarLoadedData.concat(this.similarData);
          } else {
            this.$message.warning("抱歉，没有找到！");
          }
        }
      })
    },
    changeChoose(id, list, flag) {
      //遍历questions数组，判断传入的id是否匹配，如果匹配则更新IsCollect来改变收藏状态
      const found = list.find(x => x.Data.ID === id)
      // console.log("最新的加入试题篮状态:", flag, " 找到了匹配的题目", found);
      if (found) {
        found.IsChoose = flag;
      }
    },

    /* 加入推题 */
    addPush(queIndex, queList) {
      let formData = new FormData();

      // console.log(this.question)
      if (this.question.ID == 0) {
        // 新增题目尚未保存，需提交题目的信息
        if (this.taskData.IsOnline > 1) {
          this.$refs.crop.getCropData((imgData) => {
            formData.append("Files", this.dataURLtoFile(imgData));
            this.addPushPost(formData, false, queIndex, queList);
          });
        } else {
          this.addPushPost(formData, false, queIndex, queList);
        }
      } else {
        this.addPushPost(formData, true, queIndex, queList);
      }
    },
    /* 加入推题调接口post */
    addPushPost(formData, queExist, queIndex, queList) {
      let pushQuestion = queList[queIndex];
      // console.log(pushQuestion, queExist, queIndex, queList);
      // console.log(queExist);
      let param = {};
      if (!queExist) {
        if (this.question.Sort == "") {
          this.question.Sort = this.taskData.questionList.length + 1;
        }
        //解析
        let points = [];
        if (this.question.KnowledgePoints && this.question.KnowledgePoints.length > 0) {
          for (let kp of this.question.KnowledgePoints) {
            points.push(kp.PointNo);
          }
        }
        let Explain = this.explainUEditor.getContent();
        this.question.Explain = Explain;

        if (this.taskData.IsOnline == 1) {
          //题干
          //let QuestionStem = this.editorCreate.txt.html();
          this.question.QuestionStem = this.html;

          // 计算题目的高度
          let style = getComputedStyle(this.showQuestion);
          this.question.RegionW = Math.round((this.taskData.TrueWidth / 210) * 793.69);
          this.question.RegionH = parseFloat(style.height);
        } else {
          this.question.RegionX = Math.floor(this.question.RegionX * 100) / 100;
          this.question.RegionY = Math.floor(this.question.RegionY * 100) / 100;
          this.question.RegionW = Math.floor(this.question.RegionW);
          this.question.RegionH = Math.floor(this.question.RegionH);
        }
        param = {
          SID: pushQuestion.Data.SID,
          HomeworkQuestionID: this.question.ID,
          QuestionType: this.question.QuestionType, //题型
          QuestionStem: this.question.QuestionStem,
          Answer:
            typeof this.question.Answer === "object"
              ? this.question.Answer.sort().join("")
              : this.question.Answer, // 正确答案
          Explain: this.question.Explain,
          DifficultLvl: this.question.DifficultLvl,
          RegionX: this.question.RegionX,
          RegionY: this.question.RegionY,
          RegionW: this.question.RegionW,
          RegionH: this.question.RegionH,
          KnowledgePoints: points,
          Score: this.question.Score,
          QuestionBankSID: this.question.SID,
          ExercisePageId:
            this.taskData.IsOnline == 3 && this.taskPages[this.paginationOpt.currentPage - 1].ExercisePageId
              ? this.taskPages[this.paginationOpt.currentPage - 1].ExercisePageId
              : 0,
          HomeworkID: this.taskData.ID, //任务单id
          HomeworkPageID:
            this.taskData.IsOnline > 1
              ? this.taskPages[this.paginationOpt.currentPage - 1].ID ||
              this.taskPages[this.paginationOpt.currentPage - 1].PageID
              : 0,
        };
      } else {
        console.log(this.taskData);
        console.log(this.question);


        param = {
          SID: pushQuestion.Data.SID,
          TaskQuestionID: this.question.ID,
          TaskListID: this.taskData.TaskListID,
        };
      }
      // 填充接口参数
      formData.append("Param", JSON.stringify(param));
      this.axios({
        method: "POST",
        url: window.hosturl + "/rest/questionBank/JoinThePushQuestion",
        data: formData,
      }).then((res) => {
        if (res.data.result == 200) {
          let data = res.data.data;
          // console.log(data, this.question, this.question.PushCount);

          if (this.question.PushCount && this.question.PushCount >= 0) {
            this.question.PushCount += 1;
          } else {
            this.question.PushCount = 1;
          }
          if (!this.question.ID) {
            this.question.ID = data.HomeworkQuestionID;
            this.question.Sort = data.HomeworkQuestionSort;
            if (data.path) {
              this.question.QuestionStemImage = data.path;
            }

            if (this.taskData.IsOnline > 1) {
              this.taskPages[this.paginationOpt.currentPage - 1].questionList.splice(
                this.question.Sort - 1,
                0,
                this.question
              );

              //把所有页的题目组合到一个数组中,并按题号排序
              this.taskData.questionList = [];
              //组合题目.
              this.taskPages.forEach((item) => {
                let ql = item.questionList;
                this.taskData.questionList = this.taskData.questionList.concat(ql);
              });
              this.taskData.questionList.sort((a, b) => {
                return a.sort - b.sort;
              });
            } else {
              this.taskData.questionList.push(this.question);
            }
          }
          pushQuestion.PushID = data.PushID;
          queList.splice(queIndex, 1, pushQuestion);
          this.$message.success("已加入推题");
        } else {
          this.$message.error(res.data.message);
        }
      })
    },
    /* 移出推题 */
    removePush(queIndex, queList) {
      let pushQuestion = queList[queIndex];
      //调搜题接口
      this.axios({
        method: "POST",
        url: window.hosturl + "/rest/questionBank/PushQuestionRemove",
        data: { ID: pushQuestion.PushID },
      }).then((res) => {
        if (res.data.result == 200) {
          pushQuestion.PushID = 0;
          queList.splice(queIndex, 1, pushQuestion);
          if (this.question.PushCount && this.question.PushCount > 0) {
            this.question.PushCount -= 1;
          }
          this.$message.success("已移出推题");
        } else {
          this.$message.error(res.data.message);
        }
      })
    },


    selSubject(val) {
      // console.log("选择科目", val);
      this.selection.subject.ID = val;
      this.getCondition();
    },

    formatSet(array1, array2) {
      let array0 = { ID: 0, Name: "全部" };
      //// console.log("+++++++原数组", array1, array2);
      array1 = [array0, ...array2];
      //// console.log("======新数组", array1, array2);
    },
    /**
     * 获取条件选项
     *
     * @returns 无返回值
     */
    getCondition() {
      let SubjectID = this.selection.subject.ID;
      this.condition.params.Subject = SubjectID;
      // console.log("获取条件选项", SubjectID);
      this.axios({
        method: "GET",
        url: window.hosturl + "/rest/questionBank/GetSelection",
        params: { SubjectID },
      }).then((res) => {
        if (res.data.result == 200) {
          let data = res.data.data;
          console.log("获取到的条件选项：", res);
          let item0 = { ID: 0, Name: "全部" };
          // // console.log(data.YearList);
          this.condition.data.YearList = ["全部", ...data.YearList]; // 年份

          this.condition.data.QuestionAbility = [{ AbilityId: "0", Name: "全部" }, ...data.QuestionAbility]; // 能力
          this.condition.data.QuestionSource = [item0, ...data.QuestionSource]; // 来源
          // // console.log(data.QuestionType);

          this.condition.data.QuestionType = [{ TypeId: 0, Name: "全部" }, ...data.QuestionType]; // 题型
          item0 = { Key: 0, Value: "全部" };
          this.condition.data.DifficultyLevel = [item0, ...data.DifficultyLevel]; // 难度
        }
      })
    },

    getKnowledgeList() {
      //获取当前科目
      let SubjectID = this.selection.subject.ID;
      let params = { Subject: SubjectID };
      this.axios({
        method: "GET",
        url: window.hosturl + "/rest/questionBank/GetKnowledgePoinForSubject",
        params: params,
      }).then((res) => {
        if (res.data.result == 200) {
          // console.log("获取科目下的知识点", res.data.data);
          this.knowledge.list = res.data.data;
          this.setDisabledStatus(this.knowledge.list)
        }
      });
    },
    setDisabledStatus(treeData) {
      treeData.forEach(item => {
        if (item.datalist && item.datalist.length === 0) {
          item.disabled = false;
        } else {
          item.disabled = true;
        }

        // 如果有子节点，递归调用
        if (item.datalist && item.datalist.length > 0) {
          this.setDisabledStatus(item.datalist);
        }
      });
    },
    knowledgeNodeClick(data) {
      //// console.log("知识点树节点被点击", data);
      if (this.knowledge.isMulti) { // 知识点多选
        //判断传入的data.No，是否已经包含在knowledge.multiList数组中，如果没有则添加
        // if (this.knowledge.multiList.indexOf(data.No) == -1) {
        //   //如果没有则添加到multiList数组中
        //   this.knowledge.multiList.push(data.No);
        // }
      } else {
        this.condition.params.KnowledgePoints = data.No;
        // this.$message({
        //   message: `点击知识点节点: ${data.Name}`,
        //   type: "success",
        // });
        this.quesBankPagination.PageIndex = 1; // 初始化
        this.getQuestionList(); // 加载列表
      }
    },


    knowledgeCheckChange(data, checked, indeterminate) {
      // console.log('选中的节点:', data, '选中状态:', checked, '是否半选:', indeterminate);

      // 你可以在这里将选中的节点信息存储到组件的 data 中
      if (checked) {
        this.knowledge.multiList.push(data.No);
      } else {
        const index = this.knowledge.multiList.indexOf(data.No);
        if (index > -1) {
          this.knowledge.multiList.splice(index, 1);
        }
      }
      //把数组转换为字符串，并用逗号分隔
      this.condition.params.KnowledgePoints = this.knowledge.multiList.join(',');
      this.getQuestionList(); // 加载列表

    },
    /**
     * 获取选择教材三级菜单的下拉框数据
     */
    getTeachingMaterial() {
      let title = "";
      // 获取教材
      this.axios({
        method: "GET",
        url: window.hosturl + "/hdkt/GetTeachingMaterial", // ForTeacher
      }).then((res) => {
        // console.log(res);
        // 检查返回的数据状态码是否为200
        if (res.data.result == 200) {

          // 将返回的数据进行处理并赋值给教材选项
          this.teachingMaterial.Options = this.filerCascader(res.data.data);
          // 否则，从状态管理中获取上一次的教材数据
          this.teachingMaterial.Data = store.state.lastTeachingMaterial;
          // console.log(this.teachingMaterial);

          // 遍历教材选项，构建标题
          for (let i = 0; i < this.teachingMaterial.Options.length; i++) {
            let item = this.teachingMaterial.Options[i];
            if (this.teachingMaterial.Data[0] == item.id) {
              title += item.name + "/";
              // 遍历当前选项的子数据
              for (let j = 0; j < item.data.length; j++) {
                let it = item.data[j];
                if (this.teachingMaterial.Data[1] == it.id) {
                  title += it.name + "/";
                  // 遍历当前子选项的子数据
                  for (let k = 0; k < it.data.length; k++) {
                    if (this.teachingMaterial.Data[2] == it.data[k].id) {
                      title += it.data[k].name;
                    }
                  }
                }
              }
            }
          }
          // console.log('标题---书名', title);

          // 判断标题长度是否大于0
          if (title > 0) {
            // 如果教材数据长度为3，则根据最后一个ID获取章节信息
            if (this.teachingMaterial.Data.length == 3) {
              this.getChapterInfoForId(this.teachingMaterial.Data[2]);
            }
          } else {
            // 如果标题长度为0，则清空教材数据
            this.teachingMaterial.Data = [];
          }
          // 将构建的标题赋值给教材的书名
          this.teachingMaterial.BookName = title;
        }
      });
    },

    /**
     * 递归过滤级联选择器数据
     *
     * @param da 级联选择器数据数组
     * @returns 过滤后的级联选择器数据数组
     */
    filerCascader(da) {
      //// console.log(" da=",da);
      for (let item of da) {
        //// console.log("   item.data",item.data);
        if (item.data.length === 0) {
          delete item.data;
        } else this.filerCascader(item.data);
      }
      return da;
    },
    updateCity(data) {
      // // console.log(data);
      if (data.ID == -1) {
        this.condition.params.AreaCode = '';
      } else {
        this.condition.params.AreaCode = data.ID;
      }
      // console.log("更新城市代码", data, this.condition.params);
      this.getQuestionList()
    },
    /**
     * 当教材发生变化时，该函数会处理相关逻辑
     */
    teachingMaterialChange() {
      // console.log("选中教材后，调用后端获取该教材的章节信息");
      // 输出本地最新数据
      // console.log("本地最新数据", this.teachingMaterial.Data);
      // 输出被选中的节点
      // // console.log(this.$refs.teachingMaterial.getCheckedNodes(true));
    },
    getChapterList(bookid) {
      // console.log("getChapterInfoForId,获取章节数据", bookid);
      this.selection.book.ID = bookid;
      this.condition.params.BookID = bookid;

      //1. 变化后, 获取后三级数据.
      // 获取章节信息
      this.axios({
        method: "GET",
        url: window.hosturl + "/hdkt/GetChapterInfoForId",
        params: { BookId: bookid },
      }).then((res) => {
        // console.log(res);

        if (res.data.result !== 200) {
          // 如果状态码不为200，则显示错误信息
          this.$message({
            message: res.data.message,
            type: "error",
          });
          console.error("返回错误状态码:", res.data.result, res.data.message);
          return;
        }

        // console.warn("返回的教材章节", res.data.data);
        this.chapters = res.data.data;
      });
    },

    /**
     * 获取指定书籍的章节数据
     *
     * @param {number} chpData 书籍ID
     */
    // getChapterData(chpData) {
    // // console.log("getChapterData,获取章节数据", chpData);
    //   this.chapters = chpData.map((item) => ({
    //     ...item, //将对象的所有可枚举属性复制到新对象中
    //     children: item.data, // 将data属性作为children属性
    //   }));
    // },

    /**
     * 显示教材
     */
    showTeachingMaterial() {
      this.teachingMaterial.isLoadCascaderChapter = true;
      this.teachingMaterial.visible = true;
    },
    closeTeachingMaterial() {
      this.teachingMaterial.Data = store.state.lastTeachingMaterial;
      this.teachingMaterial.visible = false;
    },

    /**
     * 确认选择教材
     *
     * @method sureTeachingMaterial
     * @returns {void}
     */
    sureTeachingMaterial() {
      // 检查是否有被选中的节点
      if (this.$refs.teachingMaterial.getCheckedNodes(true).length > 0) {
        const bookid = this.teachingMaterial.Data[2];
        // 获取被选中节点的第一个节点的路径标签的第一个元素，并赋值给taskData的Subject属性
        this.taskData.Subject = this.$refs.teachingMaterial.getCheckedNodes(true)[0].pathLabels[0];
        // console.log("====> 选择级联菜单：", this.teachingMaterial);

        this.getChapterList(bookid);
      }

      //2. 变化后, 保存到服务器(为备课中心用).  我不想多个axios同时写了....
      if (this.teachingMaterial.Data.length == 3) {
        this.axios({
          method: "POST",
          url: window.hosturl + "/hdkt/SaveTeachingMaterialForTeacher",
          data: {
            subjectID: this.teachingMaterial.Data[0],
            editionID: this.teachingMaterial.Data[1],
            bookID: this.teachingMaterial.Data[2],
          },
        }).then((res) => {
          if (res.data.result !== 200) {
            this.$message({
              message: "保存失败,请重新选择教材",
              type: "error",
            });
            return;
          }
          //3. 修改成功后, 直接替换五级.
          store.commit("upLastTeachingMaterial", this.teachingMaterial.Data);
          //4. 修改成功后, 更换显示名称
          this.teachingMaterial.BookName = this.$refs["teachingMaterial"].inputValue;

          // console.log("sureTeachingMaterial,teachingMaterial, 关闭对话框, 并保存数据到服务器.");
          //// console.log(this.$refs['teachingMaterial'].inputValue);
          this.teachingMaterial.visible = false;
          this.taskData.cascaderChapter[0] = this.teachingMaterial.Data[0];
          this.taskData.cascaderChapter[1] = this.teachingMaterial.Data[1];
          this.taskData.cascaderChapter[2] = this.teachingMaterial.Data[2];
          this.selection.subject.ID = this.teachingMaterial.Data[0];
          this.selection.edition.ID = this.teachingMaterial.Data[1];
          this.selection.book.ID = this.teachingMaterial.Data[2];
        });
      } else {
        this.teachingMaterial.BookName = "";
        this.chapter = "";
        this.teachingMaterial.visible = false;
        this.taskData.cascaderChapter = [];
      }
    },
    selectActive(flag) {
      this.pageStyle.chapterActive = !this.pageStyle.knowledgeActive;
      this.pageStyle.knowledgeActive = !this.pageStyle.chapterActive;
    },
    selectType(type) {
      let flag = true;
      if (type === 1) {
        this.pageStyle.chapterActive = true;
        this.pageStyle.knowledgeActive = false;
        this.condition.params.Type = 1; //按章节
        this.condition.params.KnowledgePoints = null;
        this.getQuestionList(); // 加载列表
      } else {
        this.pageStyle.chapterActive = false;
        this.pageStyle.knowledgeActive = true;
        this.condition.params.Type = 2; //按知识点

        // 每次点击默认把一级的所有节点拼接传递查询
        const noList = this.knowledge.list.map(item => item.No);
        // 将所有No拼接成以逗号分隔的字符串
        const noString = noList.join(',');
        // 赋值给this.condition.params.KnowledgePoints
        this.condition.params.KnowledgePoints = noString;
        this.getQuestionList(); // 加载列表
      }
    },

    // 章节树节点被点击
    treeNodeClick(data, node) {
      // console.log("章节树节点被点击", data, node);
      this.condition.params.ChapterID = data.id
      this.quesBankPagination.PageIndex = 1; // 初始化
      this.getQuestionList(); // 加载列表
    },

    filterKnowledgeNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    sortQuestionList(id) {// 切换排序方式时自动加载数据，其他条件不自动加载（点击搜索后才刷新）
      // this.condition.params.Sort = id;
      if (this.condition.params.Sort == id) { // 如果点击的同一个，就只是切换升序降序
        if (this.condition.params.Desc == 1) {
          this.condition.params.Desc = 0
        } else {
          this.condition.params.Desc = 1
        }
      } else {
        this.condition.params.Desc = 1 // 默认成降序
        this.condition.params.Sort = id;
      }
      this.getQuestionList()
    },
    changeQuestionType(id) {
      // console.log("选择题型", id, this.condition.params.QuestionType);
      this.condition.params.QuestionType = id;
      // console.log("选择题型", id, this.condition.params.QuestionType);
    },
    changeDifficultyLevel(id) {
      this.condition.params.DifficultyLevel = id;
      // console.log("选择难度DifficultyLevel", this.condition.params.DifficultyLevel);
    },
    /**
     * 更改题目类别
     *
     * @param {Object} item - 包含题目信息的对象
     */
    changeQuestionCategory(item) {
      // // console.log(item);

      const id = item.ID;
      //从this.condition.data.QuestionCategorys数组中获取所有属性为name 的值保存为数组

      const names = this.condition.data.QuestionCategorys.map((x) => x.Key);
      console.warn("题类：", names);
      names.forEach((key) => {
        this.condition.params[key] = false;
      });
      // console.log(id, this.condition.params[item.Key]);

      if (id == 0) {  // 全部题类
      } else {
        this.condition.params[item.Key] = true
        // this.condition.params[item.Name] = true;
      }
      // console.log(this.condition.params[item.Key]);

      this.condition.QuestionCategoryID = id;
      // console.log("题类：", this.condition.QuestionCategoryID);

    },
    changeQuestionSource(id) {
      // this.condition.QuestionSourceID = id;
      this.condition.params.QuestionSources = id;
    },
    changeExamYear(id) {
      // // console.log(id);
      this.condition.ExamYearID = id
      if (id == "全部") {
        this.condition.params.QuestionYear = "";
      } else {
        this.condition.params.QuestionYear = id;
      }
    },
    changeAbility(id) {
      this.condition.params.TopicNo = id;
    },
    search() {
      let errorCount = 0;
      let msg = [];
      // //确定击了搜索按钮
      // if (this.condition.params.AreaCode === "") {
      //   msg.push("请选择地区");
      //   errorCount++;
      // }
      // if (this.condition.params.ChapterID === "0") {
      //   msg.push("请选择章节");
      //   errorCount++;
      // }
      // if (this.condition.params.KnowledgePoints === "") {
      //   msg.push("请选择知识点");
      //   errorCount++;
      // }

      if (errorCount > 0) {
        this.$message.error(msg.join("，"));
        return;
      }
      this.quesBankPagination.PageIndex = 1; // 初始化

      this.getQuestionList();
    },
    getQuestionList() { // 获取挑题列表
      // console.log('获取挑题列表');

      //this.condition.params.ChapterID=param;
      this.condition.params.PageSize = this.util.deepClone(this.quesBankPagination.PageSize) // 每页记录数（小于等于10）
      this.condition.params.PageIndex = this.util.deepClone(this.quesBankPagination.PageIndex)// 当前页
      // console.log("按条件搜题", this.condition.params);
      // console.log(this.taskData);
      // console.log(this.question);
      this.condition.params.QuestionID = this.util.deepClone(this.question.ID)// 题目id

      this.axios({
        method: "GET",
        url: window.hosturl + "/rest/questionBank/GetQuestionBankListCondition",
        params: this.condition.params,
      }).then((res) => {
        // console.log(res);

        if (res.data.result === 200) {
          let data = res.data.data;
          // console.log("获取挑题列表：", res.data.data);
          this.quesBankPagination.PageIndex = data.PageIndex;
          this.quesBankPagination.PageSize = data.PageSize;
          // this.quesBankPagination.TotalSize = data.TotalSize;
          if (data.DataList.length) {
            this.QuestionList = data;
            // console.log(this.QuestionList);

            this.emptyData = false
          } else {
            this.emptyData = true
          }
        } else {
          this.$message.error("获取挑题列表错误", res.data.message);
          console.warn("获取挑题列表失败=====>", res);
        }
      });
    },

    /**
     * 初始化图表
     *
     * 初始化页面上的两个图表：饼图和柱状图。
     * 使用 ECharts 库来创建图表实例，并将它们分别绑定到 Vue 组件中的 ref 引用上。
     */

    /**
     * 初始化数据
     *
     * 从Vuex的state中获取最新的教材标签和教材ID，然后根据selectionKeys中的键（subject、edition、book）
     * 为每个键创建一个对象，该对象包含ID和Name属性，并将这些对象存储到this.selection中。
     */
    initData() {

      const labels = store.state.lastTeachingMaterialLabels; // Name
      const ids = store.state.lastTeachingMaterial; // ID
      const selectionKeys = ["subject", "edition", "book"];
      this.selection.subject = { ID: ids[0], Name: labels[0] }; // 单独获取Subject对象，用于后续操作。
      this.condition.params.PaperID = this.paperId;
      let bookid = ids[2];
      this.condition.params.BookID = bookid; //设置书本ID，用于筛选题目列表
      this.getChapterList(bookid); //获取章节列表

      //this.condition.params.ChapterID=ids[2];//设置书本ID，用于筛选题目列表

      // console.log("+++++++...++++初始化数据", labels, ids);
      //获取labels的后两个元素，并将其赋值给selection.

      selectionKeys.forEach((key, index) => {
        this.selection[key] = {
          ID: ids[index],
          Name: labels[index],
        };
      });
      //// console.log("++++++++++++初始化数据完成", this.selection);
    },
  },

  /**
   * 在组件即将被销毁之前执行一些清理操作，例如释放资源、销毁图表等。
   */
  beforeDestroy() {
    if (this.pieChartObj) {
      this.pieChartObj.dispose();
    }
    if (this.barChartObj) {
      this.barChartObj.dispose();
    }
  },
  watch: {
    // 监听 dateRangeFlag 的变化
    dateRangeFlag(val) {
      // console.log("监听：", this.errorDateRangeFlag, val);
      this.errorDateRangeFlag = val;
      // console.log("监听：", this.errorDateRangeFlag, val);
    },
    knowledgeKeyword(val) {
      this.$refs.tree.filter(val);
    },
    // "condition.params.AreaCode"(newVal, oldVal) {
    // // console.log("监听：城市新代码", newVal, "旧代码：", oldVal);
    //   if (newVal.ID != oldVal.ID) {
    //     this.condition.params.AreaCode = newVal.ID.toString();
    //  // console.log("监听城市代码：", this.condition.params.AreaCode);
    //   }
    // },

    "teachingMaterial.BookName"(newVal) {
      if (!newVal) {
        this.Title = "";
        return;
      }
      const parts = newVal.split("/");
      if (parts.length < 2) {
        this.teachingMaterial.Title = newVal;
      } else {
        this.teachingMaterial.Title = parts.slice(-2).join("/");
      }
    },

    /**
     * 当 选择教材 发生变化时触发的回调函数。
     *
     * @param newVal 新的 teachingMaterial.BookName 值
     * @param oldVal 旧的 teachingMaterial.BookName 值
     */
    //   teachingMaterialTitle(newVal, oldVal) {
    //  // console.log("监听：", newVal);
    //     //将title字符串中的第一个分隔符“/”前的文字去掉，只保留后面的文字（后边也可能有分隔符）
    //     let titles = newVal.split("/") || [];
    //  // console.log("titles：", titles);
    //     if (titles.length > 0) {
    //  // console.log("titles：", titles);
    //       titles.shift();
    //  // console.log("titles去除了第一个元素", titles);
    //       this.teachingMaterial.Title = titles.join(" ") || "";
    // // console.log("教材的显示名称", titles);
    //     } else {
    //       this.teachingMaterial.Title = "请选择教材版本→";
    //     }
    //   },
  },
};
</script>

<style lang="less" scoped>
@topHeight: 40px;
@popwidth: 40vw;

@keyframes slideRight {
  from {
    right: 2vw;
  }

  to {
    right: @popwidth;
  }
}

@keyframes slideLeft {
  from {
    right: @popwidth;
  }

  to {
    right: 2vw;
  }
}

.selQuestion {
  background-color: #f0f0f0;
  // position: absolute;
  // width: 100vw;
  // height: 100%;
  // max-height: 100%;
  // z-index: 10;

  .teachingMaterial {
    .el-cascader {
      display: block;
    }

    .el-select {
      display: block;
    }
  }


  .bodyPanel {
    background-color: #f5f5f5;
    margin: 0px auto;
    height: calc(100% - 40px);

    .el-row {
      margin-left: 0px !important;
      margin-right: 0px !important;
      background-color: #fff;
      height: 100%;

      .el-col-6 {
        // height: 100vh;
        height: 100%;
        background-color: #fff;
        // overflow-y: auto;
        padding: 5px;
        // height: calc(100vh - 112px) !important;


        .knowledgeBox {
          flex: 1;
          font-size: 12px;

          .el-card__header {
            padding: 5px;

            .el-input__inner {
              border-radius: 20px;
            }
          }

          .el-card__body {
            padding: 5px;

            .multiBox {
              position: relative;


              // .el-radio-group {
              //   position: absolute;
              //   right: -20px;
              //   top: 2px;

              //   .el-radio {
              //     margin-right: 5px;

              //     .el-radio__label {
              //       font-size: 12px;
              //       padding-left: 2px;
              //     }
              //   }
              // }
            }

            .el-tree {
              padding: 10px;
              background-color: #fff;
            }


          }

          .el-tree.filter-tree {

            .el-tree-node__children {
              :deep(.el-checkbox.is-disabled) {
                display: none !important;
              }
            }
          }
        }

        .chapterBox {
          flex: 1;

          .el-card__header {
            padding: 10px;
            border-bottom: 2px solid #008afb;

            .chapterTitle {
              >span {
                display: inline-block;
                white-space: nowrap;
                text-overflow: ellipsis;
                width: calc(100% - 30px);
                font-size: 14px;
                color: #008afb;
                font-weight: bold;
                overflow: hidden;
              }

              .el-button {
                >span {
                  color: #333;
                  font-size: 16px;
                }
              }
            }
          }
        }

        div {
          .custom-tabs .el-tabs__item {
            flex-basis: 50%;
            /* 设置标签页的基础宽度为 50% */
            max-width: 50%;
            /* 设置标签页的最大宽度为 50%，以防止内容溢出 */
          }
        }

        .custom-tree-lines {
          .el-tree-node__expand-icon {
            display: none;
            /* 隐藏默认的展开图标 */
          }

          .el-tree-node {
            /deep/ .el-tree-node__children {
              position: relative;
              /* 确保子节点的定位是相对于其父节点 */
            }

            /* 隐藏没有子节点的虚线 */
            /deep/ .el-tree-node__children::before {
              content: "";
              /* 创建一个空的伪元素 */
              position: absolute;
              /* 绝对定位 */
              top: 0;
              /* 从顶部开始 */
              bottom: 0;
              /* 到底部结束 */
              left: 12px;
              /* 放置在子节点的左侧 */
              border-left: 1px dashed #ccc;
              /* 添加虚线样式 */
            }

            /deep/ .el-tree-node__children:empty::before {
              display: none;
            }

            /* 可选：调整节点之间的间距以适应虚线 */
            /*
          /deep/ .el-tree-node {
          }
          */
          }
        }
      }

      .el-col-18 {
        padding: 5px;
        background-color: #f5f5f5;
        // height: 100vh;
        max-height: 85vh;
        height: auto;
        overflow: auto;

        // height: calc(100vh - 112px) !important;

        .conditionBox {
          background-color: #fff;

          .el-row {
            border-bottom: #e8e8e8 1px dotted;

            .el-col {
              margin: 10px 0px;
            }

            .first {
              text-align: right;
            }

            .el-col-21 {
              .el-button {
                margin-left: 0px;
              }
            }

            .el-col-12 {
              text-align: left;
            }

            .el-col-9 {
              text-align: left;

              .el-input {
                width: 75px;
                margin-right: 5px;

                i {
                  line-height: 24px;
                }

                input {
                  height: 24px;
                  padding: 5px;
                }
              }

              .el-button {
                color: #fff;
              }
            }
          }

          .el-button {
            padding: 5px 10px;

            .el-button-text {
              color: #777;
            }
          }

          .el-checkbox {
            span {
              color: #f30;

              span {
                border: #f30 1px solid;
              }

              input {
                border: #f30 1px solid;
                color: #f30;
              }
            }
          }
        }

        .questionListBox {
          background-color: #fff;
          // height: calc(100% - 320px);
          // overflow-y: scroll;

          transition: transform 0.3s ease;
          background-color: #fff;

          // height: calc(100vh - 112px) !important;
          .el-card {
            margin: 10px auto;
            width: 95%;
            border-radius: 10px;
            border: #ddd 1px solid;

            .el-card__body {
              padding: 0;

              .content-area {
                .question-body {
                  margin-bottom: 10px;
                }

                .options-area ul {
                  list-style: none;
                  padding: 0;
                }
              }

              footer {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 5px 20px 5px 0px;
                background-color: #f4f4f4;
                border-top: #e2e2e2 1px solid;
                color: #777;

                .left-area {
                  float: left;
                  font-size: 12px;

                  span {
                    margin: 0px 5px 0px 10px;
                  }
                }

                .right-area {
                  float: right;
                  text-align: right;

                  .el-button {
                    padding: 5px;
                    margin: 0px;

                    i {
                      color: #008afb;
                    }
                  }

                  .icon-belike {
                    background-image: url("../../assets/images/belike32.png");
                    background-size: 15px;
                    background-repeat: no-repeat;
                    display: inline-block;
                    width: 13px;
                    height: 13px;
                  }

                  .el-button:last-child {
                    margin-left: 10px;
                    color: #fff;

                    i {
                      color: #fff;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .type-btn-select {

      .el-button {
        // // color: #fff;
        // border: none;
        // height: 40px;
        // background-color: transparent;
        transition: all 0.3s ease;

        &.actived {
          // background-color: #fff !important;
          // color: #008afb !important;
          background-color: #008afb !important;
          color: #fff !important;

          font-weight: bold;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        &:not(.actived) {
          background-color: #fff !important;
          color: #008afb !important;
        }
      }


    }
  }

}

:deep(.el-dialog.similar-dialog.s-d) {
  border-radius: 10px;
  height: 90vh;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .el-dialog__header {
    padding: 10px 20px 10px;
    border-radius: 10px 10px 0 0;
    background: #2489f6 !important;
    color: #fff;

    .el-dialog__headerbtn {
      top: 10px;
      font-size: 20px;

      .el-dialog__close {
        color: #fff;
      }
    }

    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #fff;
    }

    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: #fff;
    }

    .el-checkbox__inner {
      background-color: transparent;
      border-color: #fff;
    }

    a.change-one {
      color: #fff;
      position: absolute;
      top: 12px;
      right: 100px;

      i {
        margin-right: 5px;
      }
    }
  }

  .el-dialog__body {
    overflow: auto;
    max-height: 500px;
    flex: 1;

    .searchIndex {
      display: flex;
      flex-direction: column;

      .query {
        margin: 15px 15px 5px 15px;
        border: 1px solid #b1afaf;
        border-radius: 10px;

        .analysis {
          margin-left: 20px;

          p {
            margin-bottom: 15px;
          }
        }

        .footer {
          display: flex;
          justify-content: space-between;
          border-radius: 10px;
          background: #eee;

          .info {
            line-height: 35px;
            margin-left: 10px;

            span {
              margin-left: 10px;
            }
          }

          .operate {
            margin-top: 3px;
            margin-right: 5%;
          }
        }
      }
    }
  }
}
:deep(.el-dialog.collect-dialog) {
  border-radius: 10px;
  height: 90vh;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .el-dialog__header {
    padding: 10px 20px 10px;
    border-radius: 10px 10px 0 0;
    background: #2489f6 !important;
    color: #fff;

    .el-dialog__headerbtn {
      top: 10px;
      font-size: 20px;

      .el-dialog__close {
        color: #fff;
      }
    }

    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #fff;
    }

    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: #fff;
    }

    .el-checkbox__inner {
      background-color: transparent;
      border-color: #fff;
    }

    a.change-one {
      color: #fff;
      position: absolute;
      top: 12px;
      right: 100px;

      i {
        margin-right: 5px;
      }
    }
  }

  .el-dialog__body {
    overflow: auto;
    flex: 1;

    .searchIndex {
      display: flex;
      flex-direction: column;

      .query {
        margin: 15px 15px 5px 15px;
        border: 1px solid #b1afaf;
        border-radius: 10px;

        .analysis {
          margin-left: 20px;

          p {
            margin-bottom: 15px;
          }
        }

        .footer {
          display: flex;
          justify-content: space-between;
          border-radius: 10px;
          background: #eee;

          .info {
            line-height: 35px;
            margin-left: 10px;

            span {
              margin-left: 10px;
            }
          }

          .operate {
            margin-top: 3px;
            margin-right: 5%;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail/selQuestion.vue